import {
  getCurrentJwt,
  setCurrentJwt,
  setCurrentRefreshToken,
  getCurrentRefreshToken
} from "../utils/helpers/jwt.helpers";
import { refreshAuth } from "./auth.service";

export async function fetchWithCredentials(url, options) {
  
  const jwtToken = getCurrentJwt();
  if(!jwtToken) {
//    GoToLogin();
window.location.href = "/";

  }

  options = options || {};
  options.headers = options.headers || {};
  options.headers["Authorization"] = "Bearer " + jwtToken;

  console.log("1) fetchWithCredentials - url", url);

  const response = await fetch(url, options);

  console.log("2) fetchWithCredentials - response", response);

  if (response.ok) return response;

  if (response.status === 401) {
    console.log("Se venció la sesión - ERROR 401", response.headers);
    // if(response.headers.has("www-authenticate")) {
    //   console.log("response.headers.has()", response.headers);
    // }
    // // && response.headers.has("www-authenticate")) {
    
    const refreshToken = getCurrentRefreshToken();
    // console.log("refreshToken", refreshToken);

    const refreshResponse = await refreshAuth(jwtToken, refreshToken);
    //console.log("refreshResponse", refreshResponse);

    if (!refreshResponse.ok) return response; // sigue habiendo un error después de refreshear el token

    const jsonRefreshResponse = await refreshResponse.json();

    //console.log("jsonRefreshResponse", jsonRefreshResponse);
    setCurrentJwt(jsonRefreshResponse.token);
    setCurrentRefreshToken(jsonRefreshResponse.refreshToken);
    return await fetchWithCredentials(url, options);
  } else {
    return response; // devuelvo el error original que hubo (no fue 401)
  }
}

export async function handleErrors(response) {
  console.log(response);
  if (!response.ok) {
    throw await response.json();
  }
  return response;
}

export async function handleErrorsStatus(response) {

  // console.log("response en handleErrorsStatus", response);

  if (response.ok) {
    if (response.status === 204) {
      return {};
    }
    return await response.json();
  } else if (response.status === 404) {
    return {};
  }

  throw await response.json();
}
